// 診断レイヤの設定値。研究方針としてすべて外出しする (閾値は実測データで較正する前提)。

export const DIAG_ENABLED: boolean = import.meta.env.VITE_DIAGNOSTICS !== "false";

/** アプリ識別子 (スナップショット id 区画) */
export const APP_ID = "fun-finds";

/** セッション区切り: この無操作時間を超えたら別セッション */
export const SESSION_GAP_MS = 30_000;

/** セッション長ヒストグラムのビン境界 (秒)。[〜30s, 〜2m, 〜5m, 5m超] の4ビン */
export const SESSION_LEN_BINS_SEC = [30, 120, 300] as const;

/** 日次バケットの保持日数 (容量制約ではなく運用方針値。eval実測で14日≈5KB) */
export const RETENTION_DAYS = 14;

/** localStorage 書き込みのスロットル間隔 */
export const PERSIST_INTERVAL_MS = 5_000;

/** エラー痕跡バッファ (スナップショット e 区画)。stack付き1件≈200Bと支配的なので少数精鋭 */
export const ERRORS_MAX = 5;
/** 間引き時にもこの件数までは残す */
export const ERRORS_TRIM_FLOOR = 2;
export const ERROR_MSG_MAX_CHARS = 120;
export const ERROR_STACK_MAX_CHARS = 160;

/** パネル表示専用のライブバッファ (QRペイロードには載せない) */
export const LIVE_EVENTS_MAX = 20;
export const LIVE_ERRORS_MAX = 10;
export const LIVE_METRIC_SAMPLES_MAX = 100;

/** タッチ途絶判定: 営業時間帯に直近この時間タッチゼロなら silent フラグ (実機稼働は0700-2000) */
export const BUSINESS_HOURS = { startHour: 7, endHour: 20 } as const;
export const TOUCH_SILENCE_MS = 3 * 60 * 60 * 1000;

/**
 * 連続QRフレーミング (SDQ1)。1QRのチャンク予算は level M 単一QR上限(2330B)より
 * 低密度寄りに固定し、超過分は枚数で吸収する。数値は実機読取実験で較正する仮値。
 */
export const QR_CHUNK_BYTES = 1200;
export const QR_MAX_PARTS = 6;
/** 間引きが目指す総バイト上限。分割が第一手段、間引きは最終手段 */
export const QR_BUDGET_BYTES = QR_CHUNK_BYTES * QR_MAX_PARTS;

/**
 * 保守パネルのQR描画サイズ (px)。旧256pxは v25級 (117モジュール+QZ) で約2px/モジュールしか
 * なく32インチ実機で読取困難だった。640pxで約5px/モジュールを確保する。
 * 狭いビューポートでは min(この値, 短辺の70%) にクランプして使う。
 */
export const DIAGNOSTICS_QR_RENDER_PX = 640;

/** 保守パネルの無操作自動クローズ (キオスクで出しっぱなし防止) */
export const MAINTENANCE_TIMEOUT_MS = 2 * 60 * 1000;

/**
 * 開いた直後のオーバーレイクリックを無視するガード時間。
 *  */
export const MAINTENANCE_OPEN_GUARD_MS = 400;

/**
 * 診断ステートのサーバーミラー先 (単一JSON文書の GET/PUT。remote.ts 参照)。null で無効。
 * 実機は Caddy(webdav) が signage/runtime/state/ に書く。エンドポイントが無い環境
 * (pages.dev・開発時) は PUT の 404/405 で自動無効化されるため既定 ON で安全。
 */
export const DIAGNOSTICS_STATE_URL: string | null = "/state/sd3-state.json";

/** Windowsサービスが書き出す起動時刻ファイル (無ければ svcBoot 省略で成立) */
export const SERVICE_BOOT_URL = "/service-boot.json";
/** svcBoot 再取得の最短間隔 (サービスのクラッシュ復旧をページ開きっぱなしでも拾う) */
export const SERVICE_BOOT_REFETCH_MS = 60_000;
